import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ELayout from "./ELayout";
import AxiosInstance from "../AxiosInstance";
import ToastNotification from "../ToastNotification";

const EProject = () => {
  const employeeId = localStorage.getItem("employeeId");
  const [projects, setProjects] = useState([]);
  const toastRef = useRef(null);

  useEffect(() => {
    const fetchEmployeeProjects = async () => {
      try {
        const response = await AxiosInstance.get(
          `/employee/fetchProjectsForEmployee/${employeeId}`
        );
        setProjects(response.data.projects);
      } catch (error) {
        toastRef.current?.showToast("Error fetching employee projects", "danger");
      }
    };

    fetchEmployeeProjects();
  }, [employeeId]);

  // Formatters
  const capitalize = (text) =>
    text ? text[0].toUpperCase() + text.slice(1) : "N/A";

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  return (
    <ELayout heading="My Projects">
      <div className="card">
        <DataTable
          value={projects}
          paginator
          rows={5}
          className="p-datatable-striped"
          emptyMessage="No projects found."
          responsiveLayout="scroll"
          stripedRows
          showGridlines
        >
          <Column field="project_id" header="#" body={(_, { rowIndex }) => rowIndex + 1} style={{ width: '4rem' }} />
          <Column field="project_name" header="Project Name" body={(row) => row.project_name.replace(/\b\w/g, (c) => c.toUpperCase())} />
          <Column field="account_value" header="Account" body={(row) => capitalize(row.account_value)} />
          <Column field="start_date" header="Start Date" body={(row) => formatDate(row.start_date)} />
          <Column field="end_date" header="End Date" body={(row) => formatDate(row.end_date)} />
        </DataTable>

        <ToastNotification ref={toastRef} />
      </div>
    </ELayout>
  );
};

export default EProject;
